'use client';

import React from 'react';
import { Flex, Link } from '@skin-seoul/design-system';
import type { ProductCardProps } from '../ProductCard.types';
import { ProductCardProvider } from '../ProductCardContext';
import ProductCardInfoName from '../components/ProductCardInfoName';
import ProductCardInfoRating from '../components/ProductCardInfoRating';
import { ProductCardInfoPrice } from '../components/ProductCardInfoPrice';
import { HorizontalProductCardContent } from './HorizontalProductCardContent';
import { HorizontalProductCardImage } from './HorizontalProductCardImage';

export const HorizontalProductCard = ({
  children,
  theme,
  onClick,
  ranking,
  orientation = 'horizontal',
  ...componentProps
}: ProductCardProps) => {
  return (
    <ProductCardProvider
      value={{
        ...componentProps,
        orientation,
        theme,
        ranking,
      }}
    >
      <Link
        unstyled
        href={componentProps.href}
        borderRadius="8px"
        display="flex"
        backgroundColor={theme === 'dark' ? 'generic.100' : 'generic.0'}
        flexDirection="row"
        height="100%"
        width="100%"
        alignItems="center"
        cursor="pointer"
        onClick={(e) => {
          e.stopPropagation();
          onClick?.(e);
        }}
      >
        <Flex width="100%" minHeight={ranking ? '164px' : '136px'} height="100%" position="relative">
          <>{children}</>
        </Flex>
      </Link>
    </ProductCardProvider>
  );
};

HorizontalProductCard.Content = HorizontalProductCardContent;
HorizontalProductCard.Image = HorizontalProductCardImage;
HorizontalProductCard.InfoName = ProductCardInfoName;
HorizontalProductCard.InfoRating = ProductCardInfoRating;
HorizontalProductCard.InfoPrice = ProductCardInfoPrice;
